import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Category, Shop} from 'interfaces';
import {
  CategoryCardLayout,
  Hero,
  HowExchange,
  InfoBar,
  ListingLayout,
  SocialProof,
  SubscriptionLayout,
  Support,
  WhyExchange,
} from 'components/Marketplace';
import {Breadcrumb} from 'components/UIKit';
import styles from '../Category.scss';
import {heroPictureData} from './images';
import * as locales from './locales';

export interface CategoriesComponentProps {
  breadcrumbs: Breadcrumb[];
  authenticityToken: string;
  shopsPath: string;
  industries: Category[];
  businessTypes: Category[];
  countries: Category[];
  staffPicks: Shop[];
  staffPicksPath: string;
  soldListings: Shop[];
  soldListingsPath: string;
}

function CategoriesComponent(props: CategoriesComponentProps & WithI18nProps) {
  const {
    breadcrumbs,
    authenticityToken,
    shopsPath,
    industries,
    businessTypes,
    countries,
    staffPicks,
    staffPicksPath,
    soldListings,
    soldListingsPath,
    i18n,
  } = props;

  const showSoldListings = Boolean(soldListings.length > 0);
  const showIndustries = Boolean(industries.length > 0);
  const showBusinessTypes = Boolean(businessTypes.length > 0);
  const showCountries = Boolean(countries.length > 0);
  const showStaffPicks = Boolean(staffPicks.length > 0);

  return (
    <>
      <InfoBar breadcrumbs={breadcrumbs} />
      <Hero
        heading={i18n.translate('heading')}
        subhead={i18n.translate('subhead')}
        cta={i18n.translate('cta')}
        url={shopsPath}
        pictureData={heroPictureData}
      />
      {showIndustries && (
        <CategoryCardLayout
          heading={i18n.translate('industries.heading')}
          subhead={i18n.translate('industries.subhead')}
          categories={industries}
        />
      )}
      {showStaffPicks && (
        <ListingLayout
          heading={i18n.translate('staffPicks.heading')}
          subhead={i18n.translate('staffPicks.subhead')}
          shops={staffPicks}
          cta={i18n.translate('staffPicks.cta')}
          ctaPath={staffPicksPath}
        />
      )}
      {showBusinessTypes && (
        <CategoryCardLayout
          heading={i18n.translate('businessTypes.heading')}
          subhead={i18n.translate('businessTypes.subhead')}
          categories={businessTypes}
        />
      )}
      {showCountries && (
        <CategoryCardLayout
          heading={i18n.translate('countries.heading')}
          subhead={i18n.translate('countries.subhead')}
          categories={countries}
          className={styles.BackgroundSilverLight}
        />
      )}
      <WhyExchange />
      <SocialProof ctaPath={shopsPath} />
      <SubscriptionLayout
        authenticityToken={authenticityToken}
        className={styles.SubscriptionContainer}
      />
      {showSoldListings && (
        <ListingLayout
          heading={i18n.translate('soldListings.heading')}
          subhead={i18n.translate('soldListings.subhead')}
          shops={soldListings}
          cta={i18n.translate('soldListings.cta')}
          ctaPath={soldListingsPath}
        />
      )}
      <HowExchange />
      <Support />
    </>
  );
}

export const Categories = withI18n({
  id: 'Categories',
  fallback: locales.en,
})(CategoriesComponent);
